import { QUERY_KEY } from '@constants';
import { useQueryClient } from '@tanstack/react-query';
import { Button, type ButtonProps, Row, Spinner } from '@viewup/ui';
import { useMarkAsReadNotification } from 'app/notifications/_features/api';

interface AllReadNotificationButtonProps extends Omit<ButtonProps, 'onClick' | 'children'> {
  label?: string;
  notificationUuids: string[];
}

export const AllReadNotificationButton = (props: AllReadNotificationButtonProps) => {
  const {
    label = '모두 읽음',
    notificationUuids,
    size = 'XS',
    variant = 'ghost.assistive',
    ...buttonProps
  } = props;
  const queryClient = useQueryClient();

  const { mutateAsync: markAsRead, isPending } = useMarkAsReadNotification({
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY.NOTIFICATIONS],
        });
      },
    },
  });

  const changeAllReadState = async () => {
    if (notificationUuids.length <= 0) return;

    await markAsRead({ notificationUuids });
  };

  return (
    <Row alignItems='center' gap={8}>
      {isPending && <Spinner size='XS' variant='threeDot' />}
      <Button
        disabled={isPending}
        size={size}
        variant={variant}
        {...buttonProps}
        onClick={() => changeAllReadState()}
      >
        {label}
      </Button>
    </Row>
  );
};
